import { render } from "./DetalleAfiliados.vue?vue&type=template&id=ed655b5e"
import script from "./DetalleAfiliados.vue?vue&type=script&lang=js"
export * from "./DetalleAfiliados.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__